var _path;
import { jsx as _jsx } from "react/jsx-runtime";
var Edit = function Edit(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.5 3.672c-1.015 0-1.99.403-2.707 1.12l-1 1-9.5 9.5A1 1 0 0 0 3 16v4a1 1 0 0 0 1 1h4a1 1 0 0 0 .707-.293l9.499-9.499h.001l.001-.002 1-.999A3.828 3.828 0 0 0 16.5 3.672Zm1 5.414.293-.293a1.828 1.828 0 0 0-2.586-2.586l-.293.293L17.5 9.086Zm-4-1.172-8.5 8.5V19h2.586l8.5-8.5L13.5 7.914Z",
      fill: "none",
      className: "tw-fill-current"
    }))
  });
};
export default Edit;